/**
 * Stories implemented
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FunctionComponent } from 'react';
import { SkeletonLine, SkeletonLineProps } from './SkeletonLine';
import { SkeletonCard, SkeletonCardProps } from './SkeletonCard';

type SkeletonAsCard = {
    /**
     * Whether to render as a card
     */
    card?: true;
    /**
     * Whether to render as a line
     */
    line?: never;
} & SkeletonCardProps;

type SkeletonAsLine = {
    /**
     * Whether to render as a card
     */
    card?: never;
    /**
     * Whether to render as a line
     */
    line?: true;
} & SkeletonLineProps;

type SkeletonProps = SkeletonAsCard | SkeletonAsLine;

const isSkeletonAsCard = (props: unknown): props is SkeletonAsCard => !!(props as SkeletonAsCard)?.card;
const isSkeletonAsLine = (props: unknown): props is SkeletonAsLine => !!(props as SkeletonAsLine)?.line;

/**
 * Renders a configurable glimmer element for showing a skeletonized UI as a Suspense/loading experience.
 */
export const Skeleton: FunctionComponent<SkeletonProps> = props => {
    if (isSkeletonAsCard(props)) {
        const { card: _, ...otherProps } = props;
        return <SkeletonCard {...otherProps} />;
    }
    if (isSkeletonAsLine(props)) {
        const { line: _, ...otherProps } = props;
        return <SkeletonLine {...otherProps} />;
    } else {
        return <></>;
    }
};
